import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './style.css';

const NotificationProvider = () => (
  <ToastContainer
    position="top-right"
    autoClose={3000}
    newestOnTop
    draggable
    closeOnClick
    pauseOnHover
  />
);

export default NotificationProvider;
